import { clientClient, personalDataClient } from 'servicesCommon/client';
import { AxiosTypedPromise, SuccessResponse } from 'servicesCommon/apiTypes';
import {
	CreateBookingRequest,
	PricesRequest,
	PricesResponse,
	UpcomingBookingsResponse,
	PastBookingsResponse,
	PostBookingParams,
	StaticMapRequest,
	StaticMapResponse,
	CreateBookingPassenger,
	BookingPassengersDetailsResponse,
	LeaveBookingFeedbackRequest,
	CancellationFeePercentagesResponse,
	CreateUpdateBookingResponse,
} from './BokkingsTypes';
import { urlFormatter } from 'utils/utils';

const formatUrl = urlFormatter('bookings');
const passengerUrl = urlFormatter('booking-passengers');

export const bookingsApi = {
	getPrice(data: PricesRequest): AxiosTypedPromise<PricesResponse> {
		return clientClient.post(formatUrl('get-prices'), data);
	},
	createBooking(data: CreateBookingRequest): AxiosTypedPromise<CreateUpdateBookingResponse> {
		return clientClient.post(formatUrl('create-booking'), data);
	},
	cancelBooking(data: { bookingId: number }): AxiosTypedPromise<SuccessResponse> {
		return clientClient.delete(formatUrl('cancel-booking'), {
			data,
		});
	},
	getUpcomingBookings(): AxiosTypedPromise<UpcomingBookingsResponse> {
		return clientClient.get(formatUrl('get-upcoming-bookings'));
	},

	getPastBookings(params?: PostBookingParams): AxiosTypedPromise<PastBookingsResponse> {
		return clientClient.get(formatUrl('get-past-bookings'), {
			params,
		});
	},
	updateBookings(data?: {
		previousBookingId: number;
		currentBookingPriceId: number;
	}): AxiosTypedPromise<CreateUpdateBookingResponse> {
		return clientClient.put(formatUrl('update-booking'), {
			...data,
		});
	},
	getStaticMap(params?: StaticMapRequest): AxiosTypedPromise<StaticMapResponse> {
		return clientClient.get(formatUrl('get-booking-route-map'), {
			params,
			responseType: 'blob',
		});
	},

	createBookingPassenger(data: CreateBookingPassenger): AxiosTypedPromise<SuccessResponse> {
		return personalDataClient.post(passengerUrl('create-booking-passenger'), data);
	},

	getBookingPassenger(params: {
		bookingId: number;
	}): AxiosTypedPromise<BookingPassengersDetailsResponse> {
		return personalDataClient.get(passengerUrl('get-full-booking-passenger-fe-by-booking-id'), {
			params,
		});
	},

	leaveBookingFeedback(data: LeaveBookingFeedbackRequest): AxiosTypedPromise<SuccessResponse> {
		return clientClient.post(formatUrl('leave-feedback'), data);
	},

	getCencellationFee(params: {
		bookingId: number;
	}): AxiosTypedPromise<CancellationFeePercentagesResponse> {
		return clientClient.get(formatUrl('get-cancellation-fee'), {
			params,
		});
	},
};
